
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './tense-explanation';
const mainimage = '/Images/grammar1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "tense" },
];


const TenseReview = () => (
  <GrammarPageLayout
    level="B1"
    title="Tense Review"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Tense Review Exercises"
    seoDescription="Review the main tenses from present simple to future perfect, plus conditionals. B1 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B1"
  />
);

export default TenseReview;
